import React from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { Grid } from 'style';
import { Markdown, Media } from '..';

const TextWithBackgroundComponent = ({
    text,
    background,
    loop,
    backgroundColor,
    textColor,
}) => (
        <Grid.Wrapper
            backgroundColor={backgroundColor && backgroundColor.hex}
            textColor={textColor && textColor.hex}
            css={text_with_background}
            id="TextWithBackgroundComponent">
            <Grid.Row>
                <TextWrapper>
                    <Markdown source={text} />
                </TextWrapper>
            </Grid.Row>

            <MediaWrapper>
                <Media image={background} loop={loop} />
            </MediaWrapper>
        </Grid.Wrapper>
    );

const TextWrapper = styled(Grid.Col)`
  @media (min-width: 1024px) {
      max-width: 50%;
      z-index: 1;
      padding-right: 0;
      position: absolute;
  }
`;
const MediaWrapper = styled.div`
  width: 100%;
  @media (min-width: 1024px) {
      z-index: 1;
      top: 0;
  }
`;
const text_with_background = css`
  position: relative;
  .media{
    width: 100%;
  }
`;
export default TextWithBackgroundComponent;
